import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config.URL_FINANCE}`;

const request = async (method, endpoint, data = null, params = null) => {
    const url = `${BASE_URL}${endpoint}`;
    try {
        const headers = await headers_get();
        return await axios({ method, url, data, headers, params });
    } catch (error) {
        console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
        throw error;
    }
};

// Funciones para interactuar con las cuentas contables
export const accounting_account_get = async (band) => {
    return request('get', '/od/accounting-account', null, { compact_view: band });
};

export const accounting_account_post = async (data) => {
    return request('post', '/od/accounting-account', data);
};

export const accounting_account_delete = async (id) => {
    return request('delete', `/od/accounting-account/${id}`);
};

export const accounting_account_put = async (id, data) => {
    return request('put', `/od/accounting-account/${id}`, data);
};
